import { render } from "./Misc.vue?vue&type=template&id=c9603380"
import script from "./Misc.vue?vue&type=script&lang=js"
export * from "./Misc.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__